import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../../provider/CommonContext";
import { Col, Container, Row } from 'react-bootstrap';
import './Rightsissues.css';
import { format, parseISO } from 'date-fns';
import Pagination from '../../../CommonUI/Pagination/Pagination';
import { useLocalStorage } from "../../../utils/useLocalStorage";
import CorporateActOption from "../../CorporateActOption/CorporateActOption";
import { Vortex } from 'react-loader-spinner';
import CallTrackApi from "../../../Activity_Track/CallTrackApi";

function Rightsissues() {
    const [data, setData] = useState([]);
  
    const [dataGroup, setDataGroup] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
   
    const { BaseURL } = useContext(URLstateContext);
    const [cocode, setcocode] = useLocalStorage("cocode", "");
    const [loadingshow, setloadingshow] = useState(false);
    let getData, getDataGroup, eleBtn, eleBtnLoose, eleLi;
    let PageSize = 8;

 
    useEffect(() => {
        window.scrollTo(0, 0)
        setloadingshow(true);
        // if (groupValue === "BSE") {
        const getUrl = BaseURL + "Rights";
        fetch(`${getUrl}/a`)
            .then((response) => response.json())
            .then((data) => {
                getData = data.data;
                setData(getData);
                //console.log(getData, "getData")
                setloadingshow(false);
            })
            .catch((error) => {
            });
      

        const getUrlGroup = BaseURL + "GroupMaster";
        fetch(`${getUrlGroup}`)
            .then((response) => response.json())
            .then((dataG) => {
                getDataGroup = dataG.data;
                setDataGroup(getDataGroup);
                //console.log(getDataGroup, "getDataGroup")
            })
            .catch((error) => {
            });

    }, []);

    const routeChange = (event) => {
        const compcocode = event.currentTarget.dataset.id;
        const compcode_array = compcocode.split('-');
        const getCoCodeId = compcode_array[0].replace(/ /g, '-').replace('&', 'and').replace('+', '');
        setcocode(compcode_array[1]);
        window.open("/stocks/" + getCoCodeId.toLowerCase(), '_blank');
    };

    const currentTableData = useMemo(() => {
        if (data != null && data != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null && data != []) {
                if (data.length > 0) {
                    return data.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, data]);
    CallTrackApi("Rights",window.location.href);

    return (
        <>
            <div class="col-12 p-0 breadcrum ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/stocks">Stocks</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>Rights</li>
                </ul>
            </div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='Rightissue-loser-sc'>
                            <div className='Rightissue-header'>
                                <h2><span>Rights Issues</span></h2>
                            </div>
                            <CorporateActOption optionCorp="Rights" />
                       
                            <hr></hr>
                            <div className='Rightissue-table table-responsive'>
                                <table className='table'>
                                    <thead>
                                        <tr>
                                            <th className='text-left'>Company Name</th>
                                            <th className='text-right'>PREMIUM (&#8377;)</th>
                                            <th className='text-center'>RATIO</th>
                                            <th className='text-center'>RECORD DATE</th>
                                            <th className='text-center'>EX DATE</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentTableData && currentTableData.map(
                                            ({ Co_NAME, premium, ratio, FROMDATE, xdate, CO_CODE }) => (
                                                <tr>
                                                    <td className="text-left">{Co_NAME}</td>

                                                    <td className="text-right">{premium}</td>
                                                    <td className="text-center">{ratio}</td>
                                                    <td className="text-center">{(FROMDATE != null) ? (format(parseISO(FROMDATE), 'dd-MMM-yyyy')) : ''}</td>
                                                    <td className="text-center">{(xdate != null) ? (format(parseISO(xdate), 'dd-MMM-yyyy')) : ''}</td>
                                                </tr>
                                            ))}
                                    </tbody>
                                </table>
                                {loadingshow ? <div className="textcentervertex">
                                    <Vortex
                                        visible={true}
                                        height="80"
                                        width="80"
                                        ariaLabel="vortex-loading"
                                        wrapperStyle={{}}
                                        wrapperClass="vortex-wrapper"
                                        colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                    />
                                    <div className="model_popup">Please Wait...</div>
                                </div> : ""
                                }


                            </div>
                            {(data != null && data != []) ?
                                <Pagination
                                    className="pagination-bar_peer"
                                    currentPage={currentPage}
                                    totalCount={(data.length != null) ? data.length : 0}
                                    pageSize={PageSize}
                                    onPageChange={page => setCurrentPage(page)}
                                /> : <p className="errorPeer"> No Data Found !!! </p>}

                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default Rightsissues;